import { graphql } from "react-relay";

export const UpdateInstructionMutation = graphql`
  mutation UpdateInstructionMutation($body: String!, $teamId: GlobalID) {
    updateInstruction(body: $body, teamId: $teamId) {
      success {
        instruction {
          id
          body
        }
      }
      error {
        message
      }
    }
  }
`;
